import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// ✅ Define the JWT State Interface
// interface JWTState {
//   isLoggedIn: boolean;
//   organizationId: number | null;
//   organizationType: string;
//   passwordExpired: string;
//   systemDate: string;
//   idToken: string | null;
// }

interface JWTState {
  userId?: number,
  token: string | null,
  isLoggedIn: boolean,
  isAdmin?: boolean,
  companyId?: number | string | null
}

// const initialState: JWTState = {
//   isLoggedIn: false,
//   organizationId: null,
//   organizationType: "",
//   passwordExpired: "",
//   systemDate: "",
//   idToken: null,
// };

const initialState: JWTState = {
  token: null,
  isLoggedIn: false,
  isAdmin: false,
  userId: 0,
  companyId: ""
};

// ✅ Create the JWT Slice
const jwtSlice = createSlice({
  name: "jwtState",
  initialState,
  reducers: {
    loginAction: (state, action: PayloadAction<JWTState>) => {
      state.token = action.payload.token;
      state.isLoggedIn = action.payload.isLoggedIn
      state.isAdmin = action.payload.isAdmin
      state.userId = action.payload.userId
      state.companyId = action.payload.companyId
    },
    logoutAction: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.isAdmin = false
      state.userId = 0
      state.companyId = null;
    }
  },
});

export const { loginAction, logoutAction } = jwtSlice.actions;

export default jwtSlice.reducer;
